module.exports = __webpack_public_path__ + "img/substack.8377dae4.svg";